<script>
	import formBase from '@_system/components/base/form.vue'
	import customerbox from '@/components/forms/offer/box/customer/list.vue'
	export default {
		extends: formBase,
		name: 'collectioncustomerForm',
		props: {

		},
		data() {
			return {

			}

		},
		render(h) {
			this.$slots.plug = [ 
				<customerbox ref="customerbox" onSubmit={this.customerboxSubmit} />,
			]
			return formBase.render.call(this, h)
		},
		watch: {

		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			customerboxSubmit(e){
				if(e.data){
					this.fApi.setValue('wlnid',e.data.customerid)
					this.fApi.setValue('code',e.data.code)
					this.fApi.setValue('name',e.data.name)
					this.fApi.setValue('title',e.data.title)
					this.fApi.setValue('address',e.data.province + e.data.city + e.data.area + e.data.address)
					this.fApi.setValue('phone',e.data.phone)
					this.fApi.setValue('bank',e.data.bank)
					this.fApi.setValue('account',e.data.account)
				}
			},
			codeButton(){
				this.$refs.customerbox.modal_show()

			}
		},
		components: {
			customerbox
		}
	}
</script>
